<template>
  <div id="FOOTER" class="footer" ref="footer">
    <div class="page_padding height100">
      <div
        class="web d-flex justify-content-between align-items-center footer_main height100"
      >
        <div class="company_info text-left line-height1 textWhite width60 ">
          <span class="fontMedium font13 block line-height1"
            >경기도 성남시 수정구 창업로 54 (시흥동 294-2) LH 기업성장센터
            807호</span
          >

          <span class="fontMedium font13"
            >springsoft@springsoft.io | Tel : 070-8864-0486</span
          >

          <div class="copyright">
            <span class="fontMedium font12"
              >2022 COPYRIGHT SPRING SOFT CO.,LTD.ALL RIGHTS RESERVED.</span
            >
          </div>
        </div>
        <div class="logo-block">
          <div class="logo">
            <img src="@/assets/source/images/logo_springsoft.png" />
          </div>
          <div v-if="!isLogin" class="admin-login font12" @click="goLogin">
            <img src="@/assets/source/images/ic_manager.png" />
            <a class="login">관리자 로그인</a>
          </div>
          <div v-else class="admin-login font12" @click="destroyLoginStorage">
            <img src="@/assets/source/images/ic_manager.png" />
            <a class="login">관리자 로그아웃</a>
          </div>
        </div>
        <div
          v-show="isScroll"
          class="top_button"
          v-on:scroll="handleScroll"
          v-on:click="scrollTop"
          :class="{is_scroll: is_scrolled}"
        >
          <div class="flex-set">
            <img src="../assets/source/images/ic_up.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="mobile footer-page-padding">
      <div class="company_info text-left line-height1 textWhite width60 ">
        <span class="font20 block line-height2"
          >경기도 성남시 수정구 창업로 54 (시흥동 294-2) <br />
          LH 기업성장센터 807호</span
        >

        <span class="font20 line-height2"
          >springsoft@springsoft.io | Tel : 070-8864-0486</span
        >
        <div class="logo">
          <img src="@/assets/source/images/logo_springsoft.png" />
        </div>
        <div class="copyright">
          <span class="fontMedium font17"
            >2022 COPYRIGHT SPRING SOFT CO.,LTD.ALL RIGHTS RESERVED.</span
          >
        </div>
      </div>
      <div
        v-show="isScroll"
        class="top_button"
        v-on:scroll="handleScroll"
        v-on:click="scrollTop"
        :class="{is_scroll: is_scrolled}"
      >
        <div class="flex-set">
          <img src="@/assets/source/images/ic_up.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {checkLogin} from "@/utils/admin";
export default {
  components: {},
  data() {
    return {
      is_scrolled: false,
      footer_height: 0,
      loginUser: localStorage.loginUser,
      isLogin: false,
      isScroll: false,
    };
  },
  computed: {
    user() {
      return localStorage.loginUser;
    },
  },
  methods: {
    handleScroll() {
      if (window.scrollY == 0 || document.documentElement.scrollTop == 0) {
        this.is_scrolled = false;
      } else {
        this.is_scrolled = true;
      }
    },
    scrollTop() {
      window.scrollTo({top: 0, behavior: "smooth"});
    },
    getFooterSize() {
      var height;
      height = document.getElementById("FOOTER").clientHeight + "px";
      this.footer_height = height;
      height = "calc(100vh - " + this.footer_height + ")";

      //not working
      this.$emit("footer", height);
    },
    destroyLoginStorage() {
      localStorage.removeItem("loginUser");
      this.$router.go(0);
    },
    goLogin() {
      this.$router.push("/login");
    },
    isScrollPage() {
      if (window.scrollY === 0) {
        this.isScroll = false;
      } else {
        this.isScroll = true;
      }
    },
    checkLogin,
  },
  beforeMount() {},
  mounted() {
    this.isScrollPage();

    window.addEventListener("resize", this.getFootersize);
    window.addEventListener("resize", this.isScrollPage);
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.isScrollPage);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getFootersize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.getFootersize);
  },
  watch: {
    $route() {
      this.isLogin = localStorage.loginUser === "springsoft";
    },
  },
};
</script>

<style scoped>
.mobile {
  display: none;
}
.imgWrap {
  width: 200px;
  margin: auto 0;
}
.footer {
  /* height: 166px; */
  padding: 2rem 0;
  background-color: #f1f1f1f1;
}
/* .logo {
  margin-right: 2rem;
} */
.height100 {
  height: 100%;
}
.textWhite {
  color: #a0a0a0;
}
span.font15 {
  line-height: 1.5rem;
}
.copyright {
  margin-top: 1rem;
}

.iconWrap {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  opacity: 0.8;
  background-color: #5f5d5d;
}
.iconWrap img {
  width: 50%;
  height: 50%;
}
.top_button .iconWrap {
  background-color: #5f5d5d;
  border-radius: 10px;
  opacity: 1;
}
.top_button.is_scroll {
  position: fixed;
  right: 60px;
  bottom: 60px;
}
/*
.logo-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
} */

.admin-login {
  width: 8rem;
  border: 1px solid #d8d8d8;
  padding: 0.3rem;
  border-radius: 1.2rem;
  background-color: #fff;
  margin: 0 auto;
}

.admin-login img {
  margin-right: 10px;
  vertical-align: middle;
}

#nav a {
  color: #919191;
}

.logo {
  width: 100%;
}

@media (max-width: 767px) {
  .top_button.is_scroll {
    right: 30px;
    bottom: 30px;
  }
}
@media (min-width: 1024px) and (max-width: 1280px) {
  .footer_main {
    flex-wrap: wrap;
  }
}
@media (max-width: 1023px) {
  .footer {
    /* height: 166px; */
    padding: 0.5rem 0;
  }
  .footer_main {
    flex-direction: column;
    justify-content: left !important;
    align-items: flex-start;
  }
  .company_info {
    width: 100%;
  }
  .sns_icon {
    margin: 0.5rem 0;
  }
  .sns_icon a:first-child {
    margin-left: 0 !important;
  }

  .logo {
    margin: 0.5rem 0;
  }
  .imgWrap {
    width: 150px;
  }
}

@media (max-width: 1023px) and (max-width: 1200px) {
  .web {
    display: none;
  }
  .mobile {
    display: block;
  }
  .footer-page-padding {
    padding: 37px 0 39px 20px !important;
  }
  .logo {
    width: 70%;
    margin: 2rem 0 0.5rem 0;
  }
  .mobile.footer-page-padding .font20 {
    font-size: 14px;
  }
  .copyright {
    font-size: 11px;
  }
}
</style>
